// Formik
import { ErrorMessage } from 'formik'

const Input = ({
  field,
  form: { touched, errors },
  label,
  required,
  placeholder,
  ...props
}) => {
  const isInvalid = !!touched[field.name] && !!errors[field.name]

  return (
    <div className='w-full'>
      <h5 className='text-sm sm:text-base font-medium capitalize pb-1'>
        {label}
        {required && <span className='text-red-700'>*</span>}
      </h5>
      <input
        {...field}
        {...props}
        placeholder={placeholder}
        invalid={isInvalid ? 'true' : 'false'}
        className='w-full border-[2px] border-light-gray focus:border-prime rounded-lg p-3 focus:outline-none focus:border-orange invalid:border-red-700'
      />
      <ErrorMessage
        name={field.name}
        component='div'
        className='text-red-700 text-sm sm:text-base font-normal absolute'
      />
    </div>
  )
}

export default Input
